import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { logout } from 'common/utils/logout';

export const AuthViewLogout = () => {
  useEffect(() => {
    logout();
  }, []);

  return <LoadingIndicator />;
};

export const AuthViewLogin = () => {
  const { state } = useLocation();
  const { redirectPath, search } = state || {};
  useEffect(() => {
    StandaloneAuth.client.loginWithRedirect({
      appState: {
        redirectPath,
        search,
      },
    });
  }, [redirectPath, search]);

  return <LoadingIndicator />;
};
